import { useState } from "react";
import Input from "ui/forms/Input";
import SimpleSelect from "ui/forms/SimpleSelect";
import Textarea from "ui/forms/Textarea";
import InputGridGroup from "./InputGridGroup";

## Basic Usage

export function BasicUsage() {
const [name, setName] = useState("");
return (

<InputGridGroup label={{ text: "Property Name", htmlFor: "property-name" }}>
  <Input
    id="property-name"
    value={name}
    onChange={(e) => setName(e.target.value)}
    placeholder="Enter property name..."
  />
</InputGridGroup>
); }

<BasicUsage />

---

## Required Field with Validation

export function RequiredField() {
const [email, setEmail] = useState("");
return (

<InputGridGroup
  label={{ text: "Email Address", required: true, secondaryText: "Used for notifications", htmlFor: "email" }}
>
  <Input
    id="email"
    value={email}
    onChange={(e) => setEmail(e.target.value)}
    placeholder="user@example.com"
    type="email"
    validate={(v) => {
      if (!v) return "Email is required";
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v))) return "Invalid email";
      return null;
    }}
  />
</InputGridGroup>
); }

<RequiredField />

---

## With Tooltip

export function WithTooltip() {
const [apiKey, setApiKey] = useState("");
return (

<InputGridGroup
  label={{
    text: "API Key",
    required: true,
    tooltip: "Find in account settings under Developer Tools",
    htmlFor: "api-key",
  }}
>
  <Input
    id="api-key"
    value={apiKey}
    onChange={(e) => setApiKey(e.target.value)}
    placeholder="Enter API key..."
    type="password"
  />
</InputGridGroup>
); }

<WithTooltip />

---

## With Select

export function WithSelect() {
const [category, setCategory] = useState("");
return (

<InputGridGroup label={{ text: "Property Category", required: true, tooltip: "Primary use category" }}>
  <SimpleSelect.Basic
    value={category}
    onValueChange={setCategory}
    items={[
      { type: "item", value: "residential", label: "Residential" },
      { type: "item", value: "commercial", label: "Commercial" },
      { type: "item", value: "industrial", label: "Industrial" },
    ]}
    placeholder="Select category..."
  />
</InputGridGroup>
); }

<WithSelect />

---

## With Textarea

export function WithTextarea() {
const [description, setDescription] = useState("");
return (

<InputGridGroup label={{ text: "Description", secondaryText: "Detailed property description", htmlFor: "desc" }}>
  <Textarea
    id="desc"
    value={description}
    onChange={(e) => setDescription(e.target.value)}
    placeholder="Enter description..."
  />
</InputGridGroup>
); }

<WithTextarea />
